import { useTranslation } from 'react-i18next'

import { AcquiringItem } from 'app/dataTypes/acquiring/settings'
import { toFixedValueCurrency } from 'app/common/lib/toFixedValue'
import { useCurrencySign } from 'app/common/components-next/currency'
import { calcCommission } from './calcCommission'

export default function useCommissionText(amount: number, acquiringItem: AcquiringItem | null) {
  const { t } = useTranslation('finances')
  const currency = useCurrencySign()

  if (!acquiringItem) return ''
  const { commissionPercent, commissionType } = acquiringItem

  const amountText = toFixedValueCurrency(amount, undefined, currency)
  if (commissionPercent !== null && commissionType !== null) {
    const commission = calcCommission(amount, commissionPercent)
    const commissionText = toFixedValueCurrency(commission, undefined, currency)
    // К оплате {{amount}}
    const firstPart = t('bank_cart_to_pay', { amount: amountText }) || ''

    const secondPart =
      commissionType === 'increase'
        ? // '\u00A0{{commission}} (сервисный сбор)'
          ` ${t('bank_cart_commission', { commission: commissionText }) || ''}`
        : // ', в\u00A0том числе {{commission}} сервисный сбор. К зачислению {{amount}}.'
          t('bank_cart_commission_internal', {
            commission: commissionText,
            amount: toFixedValueCurrency(amount - commission, undefined, currency),
          }) || ''

    return `${firstPart}${secondPart}`
  }

  return amountText
}
